// usePreviousLocation.js
import { useContext } from 'react';
import { PreviousLocationContext } from './PreviousLocationContext.jsx';

// Custom hook to use the PreviousLocationContext
const usePreviousLocation = () => useContext(PreviousLocationContext);

export default usePreviousLocation;